// Animate only changed availability copy; never delay stock checks or button guards.
const reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
function initializeStockMotion() {
  document.querySelectorAll('[data-nv-size-scope]').forEach(scope => {
    if (scope.dataset.nvStockMotion) return;
    scope.dataset.nvStockMotion = 'true';
    const selectors = ['.product-inventory__status', '.nv-store-trigger .product-store-availability__summary'];
    const previous = new Map();
    const update = () => {
      // PDP availability is shown per selected size; suppress the product-wide stock badge.
      scope.querySelectorAll('.product-page-badges .product-badges-global__label, .nv-mobile-gallery-badges .product-badges-global__label').forEach(label => {
        if (['Skladem (odesíláme do 3 dnů)', 'Vybrané velikosti skladem'].includes(label.textContent.trim())) {
          label.closest('.product-badges-global__badge')?.remove();
        }
      });
      for (const selector of selectors) {
        const node = scope.querySelector(selector);
        if (!node) continue;
        const text = node.textContent.replace(/\s+/g, ' ').trim();
        const last = previous.get(selector);
        previous.set(selector, text);
        if (last === undefined || last === text || reducedMotion.matches) continue;
        node.getAnimations().forEach(animation => animation.cancel());
        node.animate([{opacity:.35, transform:'translateY(3px)'}, {opacity:1, transform:'translateY(0)'}], {duration:280, easing:'cubic-bezier(.22,1,.36,1)'});
      }
    };
    update();
    const observer = new MutationObserver(update);
    observer.observe(scope, {subtree:true, childList:true, characterData:true});
  });
}
initializeStockMotion();
document.addEventListener('shopify:section:load', initializeStockMotion);
